import React from 'react';

import { useAppSelector } from '../../../redux/hooks';

import * as common from 'libs/common';

import { Layout, Menu, Row, Col, Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

const WithInfoTop: React.FC = (props:any) => {
    const {Header}  = Layout;
    const currentTopMenuKey = useAppSelector((state) => state.Frame.currentTopMenuKey);
    const allMenuItems = useAppSelector((state) => state.Frame.allMenuItems);
    
    const items:any = [];
    allMenuItems.forEach((item:any) => {
        if (item.menuLvl === '1') {
            const subMenuItems = allMenuItems.filter((sub:any) => {
                return sub.upperMenuId === item.menuId;
            });
            const arrSubMenus:any = [];

            // const param = { menuId : item[0] as string };
            // common.openPage(param);
            
            subMenuItems.forEach((sub:any) => {
                arrSubMenus.push({
                    key  : sub.key,
                    label: sub.title,
                    onClick : (item:any) => {
                        const param = { menuId : item.key as string };
                        common.openPage(param);
                    }
                });
            });

            items.push({
                key  : item.menuId,
                label: item.menuNm,
                children : arrSubMenus,
            });
        }
    });

    React.useEffect(() => {
        common.showLoading(false);
    }, []);

    const logout = () => {
        const param = {
            title : '위드정보 확인',
            contents: '로그아웃 하시겠습니까?',
            accept : () => {
                common.logout();
            }
        };
        common.openConfirm(param);
    }

    return (
        <Header>
            <Layout>
                <Row style={{width:'100%'}}>
                    <Col flex='9.5'><a href='/'><Col className='logoWithInfo margin-right-5'/></a></Col>
                    <Col flex='0.5'><Button icon={<LogoutOutlined/>} onClick={logout} style={{marginRight: 15}} size='small'/></Col>
                </Row>
                <Row>
                    <Col>
                        <Menu mode='horizontal' items={items} activeKey={currentTopMenuKey} onClick={item => common.setCurrLeftMenuClick(item)} selectedKeys={[currentTopMenuKey]}/>
                    </Col>
                </Row>
            </Layout>
        </Header>
    );
}

export default WithInfoTop;